module.exports = __webpack_public_path__ + "img/vrch-s-kapuci_81_seda.4609a5e6.png";